import removeDiacritics from './removeDiacritics';

const UNIT = [
    'noll',
    'ett',
    'två',
    'tre',
    'fyra',
    'fem',
    'sex',
    'sju',
    'åtta',
    'nio',
    'tio',
    'elva',
    'tolv',
    'tretton',
    'fjorton',
    'femton',
    'sexton',
    'sjutton',
    'arton',
    'nitton',
];
const TENS = ['', 'tio', 'tjugo', 'trettio', 'fyrtio', 'femtio', 'sextio', 'sjuttio', 'åttio', 'nittio'];

export function numberToWord(number = '') {
    // Starts with 0 (I.e. 007 --> nollnollsju)
    if (number.startsWith('0')) {
        let result = '';
        for (let i = 0; i < number.length; i++) {
            result += UNIT[parseInt(number[i], 10)];
        }

        return result;
    }

    // 1-9
    if (number.length === 1) {
        return UNIT[parseInt(number, 10)];
    }

    // 10-99
    if (number.length === 2) {
        const parsedNumber = parseInt(number, 10);

        // 10-19
        if (parsedNumber < 20) {
            return UNIT[parsedNumber];
        }

        // 20 - 99
        const tens = parseInt(number[0], 10);
        const unit = parseInt(number[1], 10);

        if (unit === 0) {
            return TENS[tens];
        }

        return TENS[tens] + UNIT[unit];
    }

    // 100-999
    if (number.length === 3) {
        const hundreds = parseInt(number[0], 10);
        const tens = parseInt(number[1], 10);
        const unit = parseInt(number[2], 10);

        // Hunreds without unit digits (I.e. 520 --> femhundratjugo)
        if (unit === 0) {
            return UNIT[hundreds] + 'hundra' + TENS[tens];
        }

        // Hundreds with unit digits
        return UNIT[hundreds] + 'hundra' + TENS[tens] + (unit === 0 ? '' : UNIT[unit]);
    }

    // 1000-9999
    if (number.length === 4) {
        const thousands = parseInt(number[0], 10);
        const hundreds = parseInt(number[1], 10);
        const tens = parseInt(number[2], 10);
        const unit = parseInt(number[3], 10);

        let result = UNIT[thousands];

        if (thousands === 1) {
            // Remove one 't' from etttusen
            result += 'usen';
        } else {
            result += 'tusen';
        }

        // 'hundra' is ommitted if 0
        if (hundreds > 0) {
            result += UNIT[hundreds] + 'hundra';
        }

        result += TENS[tens];

        // unit is ommitted if 0
        if (unit > 0) {
            result += UNIT[unit];
        }

        return result;
    }
}

export function removeSpecialCharacters(str) {
    return str.replace(/'|:|-|\/|<|>|@|\\|"|\.|,|–|\*|!|\?+/g, '');
}

export function normalizeAnd(str) {
    return str.replace(/\&/g, 'och').replace(/ and /g, ' och ').replace(/ o /, ' och ');
}

export function collapseWhitespace(str, removeWhitespace = false) {
    return str.replace(/\s+/g, removeWhitespace ? '' : ' ').trim();
}

export function normalizeNumbers(str) {
    return str.replace(/(\d)+/g, numberToWord);
}

export default function normalizeSearchTerm(str, removeWhitespace = false) {
    let result = removeDiacritics(str);
    result = result.toLowerCase();
    result = normalizeNumbers(result);
    result = removeSpecialCharacters(result);
    result = normalizeAnd(result);
    result = collapseWhitespace(result, removeWhitespace);

    return result;
}
